import React, { useState } from "react";
import api from "../../../services/api.js";
import { RefreshCcw } from "lucide-react";

const SyncPppActiveConByUsermanId = ({ usermanId, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleSync = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      await api.post(
        `/ppp-active-con-by-id/${usermanId}`,
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (onSuccess) {
        onSuccess();
      }

      alert("PPP Active berhasil disinkronisasi");
    } catch (err) {
      console.error(err);

      alert(err?.response?.data?.message || "Gagal melakukan sinkronisasi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleSync}
      disabled={loading}
      className="
        flex items-center gap-2
        px-4 py-2
        rounded
        bg-blue-600
        text-white
        hover:bg-blue-700
        disabled:opacity-50
      "
    >
      <RefreshCcw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />

      {loading ? "Syncing..." : "Sync Active"}
    </button>
  );
};

export default SyncPppActiveConByUsermanId;
